import { Pipe, PipeTransform } from '@angular/core';
/*
 * Divide the value by given arg and perform ceiling operation
 * Takes a divider argument that defaults to 1.
 * Usage:
 *   value | divideBy:divider
 * Example:
 *   {{ 20 | divideBy:10 }}
 *   formats to: 20
*/
@Pipe({name: 'divideBy'})
export class DivideByPipe implements PipeTransform {
  transform(value: number, divider?: number): number {
    divider = isNaN(divider) ? 1 : divider;
    return Math.ceil(value / divider);
  }
}